export default __webpack_public_path__ + "static/media/Heroku.7c461f5d.png";